<template>
  <div>
    <modal-q v-if="isLoading"></modal-q>
    <v-layout row wrap>
      <v-flex lg6 style="position: relative">
        <div class="hide" v-if="isFree">
          <h1>{{ getString("Solo utenti Silver o Platinum") }}</h1>
        </div>
        <v-card class="dash-card">
          <v-toolbar class="q-orange-bk q-text-whitesmoke" height="50px">
            <v-toolbar-title>{{
              getString("Crea comunicazione")
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <div>
              <v-flex xs12>
                <v-text-field
                  maxlength="30"
                  :counter="30"
                  v-model="titleProp"
                  solo
                  :label="getString('Titolo')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 class="elevation-3">
                <editor
                  api-key="vn43j4ndioj2ysq09jicr7yfha8fvqcp8kye03mrgsixspv4"
                  v-model="message"
                  :init="{
                    selector: 'textarea',
                    language_url: '../../../static/languages/tinymce/it.js',
                    menubar: false,
                    plugins: ['image lists'],
                    image_description: false,
                    image_dimensions: false,
                     file_picker_callback:  (cb, value, meta) => {},
                    a11y_advanced_options: true,
                    automatic_uploads: true,
                    file_picker_types: 'image',
                    image_prepend_url: '/../../../../static/img/',
                    image_list: [
                      { title: 'Cat', value: 'default-avatar.png' },
                      { title: 'Dog', value: 'dog.jpg' },
                    ],
                    min_height: 400,
                    branding: false,
                  }"
                ></editor>
              </v-flex>
              <div
                :class="{ counter: true, 'counter-red': message.length > 1900 }"
              >
                <h5>{{ countChar }}/2000</h5>
              </div>
              <v-flex xs12 lg6>
                <v-datetime-picker
                  format="DD/MM/YYYY HH:mm"
                  label="Seleziona la data di scadenza"
                  okText="Conferma"
                  clearText="Annulla"
                  v-model="expire"
                  locale="it-it"
                ></v-datetime-picker>
              </v-flex>
              <v-layout row wrap>
                <!--
                  <v-flex lg4>
                                  <v-checkbox :label="getString('Email')" v-model="cb_EmailShop"></v-checkbox>
                              </v-flex>
                              <v-flex lg4>
                                  <v-checkbox :label="getString('Push a singolo utente')" v-model="cb_PushUser"></v-checkbox>
                  </v-flex>
                -->
                <!--
                  <v-flex lg4>
                                  <v-checkbox :label="getString('Push a tutti')" v-model="cb_PushUsers"></v-checkbox>
                  </v-flex>
                -->
                <p>
                  {{
                    getString("Invia una comunicazione a tutti i tuoi clienti")
                  }}
                </p>
              </v-layout>
            </div>
          </v-card-text>
          <v-progress-linear
            indeterminate
            active
            v-if="loading"
          ></v-progress-linear>
          <v-card-actions>
            <v-btn
              :disabled="loading"
              class="q-orange-bk q-text-whitesmoke"
              @click="sendCommunication"
              >Invia</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex lg6>
        <v-card class="dash-card">
          <v-toolbar class="q-orange-bk q-text-whitesmoke" height="50px">
            <v-toolbar-title>{{
              getString("Lista comunicazioni")
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-data-table
            :headers="Headers"
            :items="communications"
            item-key="idCommunication"
            :rows-per-page-items="[10, 20, 30]"
            :rows-per-page-text="getString('Date per pagina')"
            :no-data-text="getString('Dati non disponibili')"
            class="elevation-0"
          >
            <template slot="items" slot-scope="props">
              <tr style="max-height: 100px; overflow: hidden">
                <td class="text-xs-center" style="padding: 0">
                  <v-btn flat @click="deleteCommunication(props.item)">
                    <v-icon class="q-danger-bk">remove_circle</v-icon>
                  </v-btn>
                </td>
                <td class="text-xs-left">
                  {{ getFormattedDateTime(props.item.created) }}
                </td>
                <td class="text-xs-left">{{ props.item.title }}</td>
                <td class="text-xs-left">
                  <v-tooltip bottom>
                    <span
                      slot="activator"
                      v-html="props.item.message.trunc(50)"
                    />
                    <span v-html="props.item.message" />
                  </v-tooltip>
                </td>
                <td class="text-xs-left">
                  {{ getFormattedDate(props.item.expire) }}
                </td>
                
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import ajax from "../../ajax.js";
import Editor from "@tinymce/tinymce-vue";
import moment from "moment";
import ModalQ from "../utils/ModalQ";

export default {
  name: "Communication",
  mounted: function () {
    if (this.shopID > 0) {
      this.getCommunications();
    }
  },
  components: {
    editor: Editor,
    ModalQ,
  },
  watch: {
    shopID: function () {
      if (this.shopID > 0) {
        this.getCommunications();
      }
    },
  },
  computed: {
    shopID: function () {
      if (this.$store.state.userShops.length > 0)
        return this.$store.state.userShops[0].idBarberShop;
      return 0;
    },
    titleProp: {
      get: function () {
        return this.title;
      },
      set: function (value) {
        if (value.length <= 30) this.title = value;
      },
    },
    Headers: function () {
      let result = [];
      let self = this;

      let temp = [
         self.getString("Rimuovi"),
        self.getString("Data:date"),
        self.getString("Titolo:title"),
        self.getString("Messaggio:message"),
        self.getString("Scadenza:Expire"),
       
      ];
      temp.forEach((element) => {
        result.push({
          text: self.getString(element.split(":")[0]),
          align: element.split(":").length > 1 ? "left" : "center",
          sortable: element.split(":").length > 1,
          value: element.split(":")[1],
        });
      });
      return result;
    },
    countChar: function () {
      return (
        this.getString("Caratteri: ") + this.stripHtml(this.message).length
      );
    },
    countCharAdmin: function () {
      return (
        this.getString("Caratteri: ") + this.stripHtml(this.messageAdmin).length
      );
    },
    isAdmin: function () {
      return this.$store.getters.isAdmin;
    },
    isFree: function () {
      return this.$store.getters.hasDlc("V10");
    },
  },
  data: () => {
    return {
      loading: false,
      isLoading: false,
      title: "",
      message: "",
      expire: null,
      titleAdmin: "",
      messageAdmin: "",
      expireDialog: false,
      communications: [],
      cb_EmailShop: false,
      cb_PushUser: false,
      cb_PushUsers: true,

      cb_EmailAll: false,
      cb_AlertShops: false,
      cb_PushAll: false,
    };
  },
  methods: {
    getString: function (key, values) {
      return this.$store.state.currentTranslator.getString(key, values);
    },
    getFormattedDate: function (date) {
      var date = moment(date);
      if (date.isValid()) return new moment(date).format("DD/MM/YYYY");
      else return "Nessuna";
    },
    getFormattedDateTime: function (date) {
      return new moment(date).format("DD/MM/YYYY HH:mm");
    },
    deleteCommunication: function (item) {
      let self = this;
      this.isLoading = true;

      ajax.axios
        .delete(
          ajax.baseUrl() + "/admin/communication/" + item.idCommunication,
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.getCommunications();
          self.isLoading = false;
        })
        .catch(function (error) {
          self.isLoading = false;
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    getCommunications: function () {
      let self = this;
      this.isLoading = true;
      let idShop = this.shopID;

      ajax.axios
        .get(ajax.baseUrl() + "/admin/communication/shop/" + idShop, {
          headers: self.$store.getters.tokenHeader,
          withCredentials: true,
        })
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.isLoading = false;
          self.communications = response.data.data;
        })
        .catch(function (error) {
          self.isLoading = false;
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    sendCommunication: function () {
      let self = this;
      if (!self.title) {
        self.$emit("siteAlert", self.getString("Il titolo è obbligatorio"));
      }
      else if (!self.message) {
        self.$emit("siteAlert", self.getString("Il testo è obbligatorio"));
      } else {
        this.loading = true;
        let idShop = this.$store.state.userShops[0].idBarberShop;
        var expireMom = moment(self.expire);
        var expireNoTimeZone = null;
        if (expireMom.isValid())
          expireNoTimeZone = expireMom.format("YYYY-MM-DDTHH:mm:ss");
        ajax.axios
          .post(
            ajax.baseUrl() + "/admin/communication/shop/" + idShop,
            {
              title: self.title,
              message: self.message,
              expire: expireNoTimeZone,
              PushAllShop: self.cb_PushUsers,
              /* EmailAllShop: self.cb_EmailShop,
            PushSingleUser: self.cb_PushUser, */
            },
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true,
            }
          )
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);
            self.loading = false;
            self.$emit("siteAlertSuccess", response.data.data.text);
            self.getCommunications();
          })
          .catch(function (error) {
            self.loading = false;
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          });
      }
    },
    stripHtml: function (html) {
      // Create a new div element
      var temporalDivElement = document.createElement("div");
      // Set the HTML content with the providen
      temporalDivElement.innerHTML = html;
      // Retrieve the text property of the element (cross-browser support)
      return (
        temporalDivElement.textContent || temporalDivElement.innerText || ""
      );
    },
  },
};
</script>

<style scoped>
.center {
  text-align: center;
}

.counter {
  text-align: right;
  margin-top: 10px;
  color: #666;
  transition: color linear 0.3s;
}

.counter-red {
  color: tomato;
}
.border {
  border: 2px solid;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/Communication.vue